import { createAction } from 'redux-actions';

import { generateApiActions } from './action-helpers';

const types = {
  FETCH_COMPANIES: 'FETCH_COMPANIES',
  SEARCH_COMPANIES: 'SEARCH_COMPANIES',
  ADD_COMPANY_COMMENT: 'ADD_COMPANY_COMMENT',
  REMOVE_COMPANY_COMMENT: 'REMOVE_COMPANY_COMMENT',
  CREATE_COMPANY: 'CREATE_COMPANY',
  UPDATE_COMPANY: 'UPDATE_COMPANY',
  DELETE_COMPANY: 'DELETE_COMPANY',
  SET_COMPANIES_PAGE: 'SET_COMPANIES_PAGE',
  SET_COMPANIES_FILTER: 'SET_COMPANIES_FILTER',
  RESET_COMPANIES_FILTER: 'RESET_COMPANIES_FILTER',
  RESET_COMPANIES_DATA: 'RESET_COMPANIES_DATA',
  RESET_SEARCH_DATA: 'RESET_SEARCH_DATA',
  UPDATE_COMPANY_CONTACTS: 'UPDATE_COMPANY_CONTACTS',
  UPDATE_COMPANY_REQUESTS: 'UPDATE_COMPANY_REQUESTS',
};

export const {
  fetchCompaniesRequest,
  fetchCompaniesSuccess,
  fetchCompaniesFailure,
} = generateApiActions(types.FETCH_COMPANIES);

export const {
  searchCompaniesRequest,
  searchCompaniesSuccess,
  searchCompaniesFailure,
} = generateApiActions(types.SEARCH_COMPANIES);

export const {
  createCompanyRequest,
  createCompanySuccess,
  createCompanyFailure,
} = generateApiActions(types.CREATE_COMPANY);

export const {
  updateCompanyRequest,
  updateCompanySuccess,
  updateCompanyFailure,
} = generateApiActions(types.UPDATE_COMPANY);

export const {
  deleteCompanyRequest,
  deleteCompanySuccess,
  deleteCompanyFailure,
} = generateApiActions(types.DELETE_COMPANY);

export const addCompanyComment = createAction(types.ADD_COMPANY_COMMENT);
export const removeCompanyComment = createAction(types.REMOVE_COMPANY_COMMENT);

export const updateCompanyContacts = createAction(types.UPDATE_COMPANY_CONTACTS);
export const updateCompanyRequests = createAction(types.UPDATE_COMPANY_REQUESTS);

export const setPage = createAction(types.SET_COMPANIES_PAGE);

export const setFilter = createAction(types.SET_COMPANIES_FILTER);
export const resetFilters = createAction(types.RESET_COMPANIES_FILTER);

export const resetCompaniesData = createAction(types.RESET_COMPANIES_DATA);
export const resetSearchDataCompanies = createAction(types.RESET_SEARCH_DATA);



// WEBPACK FOOTER //
// ./src/redux/actions/companies.js